"use client";

import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { thunks } from "@/lib/redux/thunks";
import { buildProductContentPublicListBody } from "@/utils/esim/buildEsimSearchBody";
import { resolveProductHomeContents } from "@/utils/esim/resolveProductHomeContents";
import { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";

/** Content đứng độc lập cho trang chủ eSIM (`position: ['PRODUCT_HOME']`) — fetch once, resolve theo ngôn ngữ hiện tại. */
export const useEsimProductHomeContent = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const requestedRef = useRef(false);
  const { contents, loading, called } = useAppSelector((state) => ({
    contents: state.esim.product_content_public_list.data.contents,
    loading: state.esim.product_content_public_list.loading,
    called: state.esim.product_content_public_list.called,
  }));

  useEffect(() => {
    if (called || requestedRef.current) return;
    requestedRef.current = true;
    dispatch(
      thunks.product_content_public_list({
        body: { TYPE: "JSON", ...buildProductContentPublicListBody("ESIM", ["PRODUCT_HOME"]) },
      }),
    );
  }, [called, dispatch]);

  const resolved = useMemo(
    () => resolveProductHomeContents(contents, i18n.language),
    [contents, i18n.language],
  );

  return { resolved, loading };
};
